import * as Yup from 'yup';
import { Chip } from '@mui/material';
// project import
import {
    FormConfigBuilder,
    GLOBAL_FIELD_PROPS,
} from 'components/form-builder/FormConfigBuilder';
import { FormFieldCustomComponentTypes } from 'constants/FormFieldCustomComponentTypes';
import { User } from 'models/nostradamus/user/User';

const schema = Yup.array(Yup.string());

// eslint-disable-next-line no-unused-vars
const formConfig = (methods = null, watch = null) => {
    return new FormConfigBuilder(
        [
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'email',
                validations: [
                    ['email', true],
                    ['max', 150],
                    ['required', true],
                ],
                list: true,
            },
            {
                componentType: FormFieldCustomComponentTypes.PasswordField,
                attribute: 'password',
                validations: [
                    ['required', true],
                    ['min', 8],
                    [
                        'test',
                        [
                            'matches',
                            'At least 1 lowercase or uppercase letter',
                            value =>
                                new RegExp('(?=.*[a-z])(?=.*[A-Z])').test(
                                    value,
                                ),
                        ],
                    ],
                    // [
                    //     'test',
                    //     [
                    //         'specialChar',
                    //         'At least 1 number or special character',
                    //         value =>
                    //             new RegExp('(?=.*[0-9])(?=.*[!@#$%^&*])').test(
                    //                 value,
                    //             ),
                    //     ],
                    // ],
                ],
                // list: true,
            },
            {
                componentType: FormFieldCustomComponentTypes.CustomAutoComplete,
                attribute: 'roles',
                title: 'Roles',
                col: {
                    // Here you can specify how many Grid columns the field should take for the corresponding breakpoints
                    sm: 12,
                },
                props: {
                    ...GLOBAL_FIELD_PROPS.props,
                    multiple: true,
                },
                optionConfig: {
                    key: 'type',
                    value: 'type',
                    label: 'label',
                },
                filterAsync: false,
                validations: [['required', true]],
                async: {
                    url: '/api/analytics/auth/roles',
                    params: {
                        unpaged: true,
                    },
                },
                list: {
                    renderCell: params => (
                        <span>
                            {Array.isArray(params?.value)
                                ? params.value.map(r => r?.label).filter(Boolean).join(', ')
                                : params?.value?.label || ''}
                        </span>
                    ),
                },
            },
            {
                attribute: 'enabled',
                title: 'Status',
                list: {
                    renderCell: params => {
                        const isEnabled = params?.value !== false;
                        return (
                            <Chip
                                label={isEnabled ? 'Enabled' : 'Disabled'}
                                size="small"
                                color={isEnabled ? 'success' : 'error'}
                                variant="outlined"
                            />
                        );
                    },
                },
            },
        ],
        User,
    );
};

export default [{ config: formConfig }];
